import mcaitLogo from "../../../design/source-assets/mcait-horizontal-white.png";
import midentalLogo from "../../../design/source-assets/midental-primary.png";
import midentalCompact from "../../../design/source-assets/midental-icon.png";

const MCAIT_LIVE_LOGO =
  "https://mcait-2026.web.app/images/mcait-2026-logo-white-horizontal.png";
const MIDENTAL_LIVE_LOGO =
  "https://midental-2026.web.app/midental-logo-primary.png";
const MIDENTAL_LIVE_ICON =
  "https://midental-2026.web.app/midental-logo-icon.png";

function uniqueLogoCandidates(
  candidates: ReadonlyArray<string | null | undefined>,
): readonly string[] {
  return Object.freeze([
    ...new Set(
      candidates.map((candidate) => candidate?.trim()).filter(Boolean),
    ),
  ] as string[]);
}

export function conferenceLogoCandidates(
  conferenceId: string,
  configuredLogo: string | null,
  compact = false,
): readonly string[] {
  const normalizedConferenceId = conferenceId.trim().toLowerCase();

  if (normalizedConferenceId === "mcait-2026") {
    return uniqueLogoCandidates([configuredLogo, MCAIT_LIVE_LOGO, mcaitLogo]);
  }
  if (normalizedConferenceId === "midental-2026") {
    return uniqueLogoCandidates([
      configuredLogo,
      compact ? MIDENTAL_LIVE_ICON : MIDENTAL_LIVE_LOGO,
      compact ? midentalCompact : midentalLogo,
    ]);
  }
  return uniqueLogoCandidates([configuredLogo]);
}

export function advanceConferenceLogoCandidate(
  currentIndex: number,
  candidateCount: number,
): number | null {
  const nextIndex = currentIndex + 1;
  return nextIndex < candidateCount ? nextIndex : null;
}

export function conferenceLogo(
  conferenceId: string,
  configuredLogo: string | null,
  compact = false,
): string | null {
  return (
    conferenceLogoCandidates(conferenceId, configuredLogo, compact)[0] ?? null
  );
}
